import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Files/Home";
import Header from "./Files/Header";
import Footer from "./Files/Footer";
import About from "./Files/About";
import Privacy from "./Files/Privacy";
import Spinner from "./Files/Spinner";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/spinner" element={<Spinner />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;